import { render, staticRenderFns } from "./doclist.vue?vue&type=template&id=5791c97b&scoped=true&"
import script from "./doclist.vue?vue&type=script&lang=js&"
export * from "./doclist.vue?vue&type=script&lang=js&"
import style0 from "./doclist.vue?vue&type=style&index=0&id=5791c97b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5791c97b",
  null
  
)

export default component.exports